import api from "@/app/api";
import { useQuery } from "@tanstack/react-query";

export const useSearchHistory = () => {
  return useQuery({
    queryKey: ['flightSearchHistory'],
    queryFn: async () => {
      const { data } = await api.get('/flight/search/history');
      return data;
    },
  });
}


export const useHotelSearchHistory = () => {
  return useQuery({
    queryKey: ['hotelSearchHistory'],

    queryFn: async () => {
      const {data} = await api.get('/search/hotel/search/history')
      return data;
    }
  })
}
